import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-selected-students-table',
  templateUrl: './selected-students-table.component.html',
  styleUrls: ['./selected-students-table.component.scss']
})
export class SelectedStudentsTableComponent implements OnInit {

  @Input("selectedStudentsToAdd") selectedStudentsToAdd;
  @Input("listFlag") listFlag;
  @Output("eventHandeler2") eventHandeler2 = new EventEmitter();
  @Input("currLang") currLang;

  constructor() { }

  ngOnInit(): void {
  }

  clearAll() {
    this.eventHandeler2.emit({
      action: 'clearAll'
    })
  }

  removeFromRoute(student) {
    this.eventHandeler2.emit({
      action: 'removeStudent',
      studentToBeRemoved: student
    })
  }

  getImage(image) {
    return environment.img_url + image;
  }

}
